import { render, staticRenderFns } from "./BaseBtnSetupPosition.vue?vue&type=template&id=653be048&scoped=true&lang=pug"
import script from "./BaseBtnSetupPosition.vue?vue&type=script&lang=js"
export * from "./BaseBtnSetupPosition.vue?vue&type=script&lang=js"
import style0 from "./BaseBtnSetupPosition.vue?vue&type=style&index=0&id=653be048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653be048",
  null
  
)

export default component.exports